import web from '@/core/middlewares/web'
import auth from "@/core/middlewares/auth";

let account = () => import(/* webpackChunkName: "account" */ '@/views/account/Account');
let changePassword = () => import(/* webpackChunkName: "account" */ '@/views/account/ChangePassword');


export default [
    {
        path: "/account",
        component: () => import("@/views/account/Layout"),
        children: [
            {
                path: "",
                name: "account.index",
                components: {
                    account: account
                },
                meta: {
                    middleware: [auth],
                    title: "حساب کاربری من"
                },

            },
            {
                path: "change-password",
                name: "account.change_password",
                components: {
                    account: changePassword
                },
                meta: {
                    middleware: web,
                    title: "تغییر گذرواژه"
                },
            },

        ]
    },
]